/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}  .mat-checkbox-label{white-space:normal}.scroll[_ngcontent-%COMP%]{overflow-y:auto}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/proxyapprove/proxyapprove.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js